import { useQuery } from '@tanstack/react-query';

import { getSoulMatrixData, ISoulMatrixData } from '../api/charts/soulMatrix';
import { IProfile } from '../types/Profile';

export const useSoulMatrixData = (profile: IProfile) => {
  return useQuery<ISoulMatrixData>({
    queryKey: ['soulMatrixData', profile.token],
    queryFn: () => getSoulMatrixData(profile.token),
    enabled: !!profile?.token,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
